/*
 * product (schema)
 */
import { boolean, doublePrecision, integer, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { producers } from "../producer/producer.schema"

export const products = schema.table("products", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	producerId: uuid("producer_id")
		.notNull()
		.references(() => producers.id, { onDelete: "cascade" }),

	// --- General ---
	name: varchar("name", { length: 256 }).notNull(),
	productType: integer("product_type").notNull(),
	quantity: doublePrecision("quantity"),
	measurement: integer("measurement"),
	description: text("description"),

	// --- Flags ---
	discontinued: boolean("discontinued").notNull().default(false),
	currentlyUnavailable: boolean("currently_unavailable").notNull().default(false),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
